export default __webpack_public_path__ + "static/media/CalendarPrimary.34ba6463.svg";